import { Accordion, Box, Text } from '@mantine/core';
import { Header } from '../../molecules';
import { ListContent, StyledAccordion } from './styles';
import { ListContextVariables } from '../list-context-variables';
import { ListTree } from '../list-tree';
import { useListView } from './use-list-view';
import { Add } from '@morph-mapper/ui';
import { CreateEntryModal } from '../create-entry-modal';
import { t } from 'i18next';
import { useEffect, useRef } from 'react';
import { useStore } from '@/store';
import { useScrollPosition } from '@/hooks';

export const ListView = () => {
  const [setHeader, clearHeader] = useStore(({ ui }) => [ui.setHeader, ui.clearHeader]);

  useEffect(() => {
    setHeader({ title: t('header.overview') });
    return () => clearHeader();
  }, [setHeader, clearHeader]);
  const {
    isCreateEntryModalOpen,
    closeCreateEntry,
    active,
    handleCreateEntry,
    handleChangeActive,
    getVariables,
    contextListActive,
  } = useListView();

  const listRef = useRef<HTMLDivElement>(null);
  useScrollPosition(listRef);

  return (
    <>
      <Header />
      <ListContent ref={listRef}>
        <StyledAccordion
          value={active}
          onChange={handleChangeActive}
          multiple
          unstyled
        >
          <Accordion.Item value="tree">
            <Accordion.Control>
              <Box>
                <Text>{t('accordion.template.title')}</Text>
                <Text size="sm" color="dimmed" weight={400}>
                  {t('accordion.template.description')}
                </Text>
              </Box>
              <Box
                component="span"
                onMouseDown={(e: React.MouseEvent) => {
                  e.stopPropagation();
                }}
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                }}
              >
                <Add component="div" onClick={handleCreateEntry} />
              </Box>
            </Accordion.Control>
            <Accordion.Panel>
              <ListTree />
            </Accordion.Panel>
          </Accordion.Item>
          <Accordion.Item value="entries">
            <Accordion.Control disabled={!contextListActive}>
              <Box>
                <Text>{t('accordion.environment.title')}</Text>
                <Text size="sm" color="dimmed" weight={400}>
                  {t('accordion.environment.description')}
                </Text>
              </Box>
            </Accordion.Control>
            <Accordion.Panel>
              <ListContextVariables variableIds={getVariables()} />
            </Accordion.Panel>
          </Accordion.Item>
        </StyledAccordion>
      </ListContent>

      <CreateEntryModal
        opened={isCreateEntryModalOpen}
        close={closeCreateEntry}
      />
    </>
  );
};
